import { defineMessages, IntlShape } from "react-intl";

import BoundaryLegendCreationVisibility from "@mapmycustomers/shared/enum/boundaryLegends/BoundaryLegendCreationVisibility";

import { getDisplayName } from "./getDisplayName";

export const messages = defineMessages<BoundaryLegendCreationVisibility>({
  [BoundaryLegendCreationVisibility.PRIVATE]: {
    id: "boundaryLegendCreationVisibility.private",
    defaultMessage: "Organization owners only",
    description: "Private option for the boundary legend creation visibility",
  },
  [BoundaryLegendCreationVisibility.SHARED_WITH_MANAGERS]: {
    id: "boundaryLegendCreationVisibility.sharedWithManagers",
    defaultMessage: "Team managers and organization owners",
    description: "Shared With Team option for the boundary legend creation visibility",
  },
  [BoundaryLegendCreationVisibility.SHARED_WITH_ORGANIZATION]: {
    id: "boundaryLegendCreationVisibility.sharedWithOrganization",
    defaultMessage: "All users",
    description: "Entire Org option for the boundary legend creation visibility",
  },
});

const getBoundaryLegendCreationVisibilityDisplayName = (
  intl: IntlShape,
  visibility: BoundaryLegendCreationVisibility
) => getDisplayName(intl, messages, visibility, "BoundaryLegendCreationVisibility");

export default getBoundaryLegendCreationVisibilityDisplayName;
